export enum RpaBotType {
    AutomationAnywhere,
    BluePrism,
    UiPath
}

export enum EListSelectionStatus {
    unselect,
    select,
    loading
  }